import "../../../../FhToastItem.css";
import { ref, onMounted, openBlock, createElementBlock, createVNode, unref, createElementVNode, createBlock, withCtx, createTextVNode, toDisplayString, resolveDynamicComponent, normalizeProps, mergeProps, withModifiers, createCommentVNode } from "vue";
import FhText from "../../../FhText/FhText.mjs";
import FhIconButton from "../../../Buttons/FhIconButton/FhIconButton.mjs";
import alertFilled from "../../../../icons/alertFilled.mjs";
import checkRoundedFilled from "../../../../icons/checkRoundedFilled.mjs";
import close from "../../../../icons/close.mjs";
import informationFilled from "../../../../icons/informationFilled.mjs";
import FhIcon from "../../../FhIcon/FhIcon.mjs";
import { VARIANTS_ENUMS } from "../../constants.mjs";
import { _ as _export_sfc } from "../../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-toast-item-content" };
const _sfc_main = {
  __name: "FhToastItem",
  props: {
    toast: {
      type: Object
    }
  },
  emits: ["hideToast"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const timeoutId = ref(null);
    const { variant, autoClose, duration, dismissible } = props.toast.options;
    const variantIconMap = {
      [VARIANTS_ENUMS.SUCCESS]: checkRoundedFilled,
      [VARIANTS_ENUMS.INFORMATION]: informationFilled,
      [VARIANTS_ENUMS.WARNING]: alertFilled,
      [VARIANTS_ENUMS.ERROR]: alertFilled
    };
    const variantIconColorMap = {
      [VARIANTS_ENUMS.SUCCESS]: "success-default",
      [VARIANTS_ENUMS.INFORMATION]: "information-default",
      [VARIANTS_ENUMS.WARNING]: "warning-default",
      [VARIANTS_ENUMS.ERROR]: "error-default"
    };
    const hideToast = () => {
      emit("hideToast", props.toast.id);
    };
    const resumeTimeout = () => {
      if (autoClose && duration) {
        timeoutId.value = setTimeout(hideToast, duration);
      }
    };
    const pauseTimeout = () => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
        timeoutId.value = null;
      }
    };
    onMounted(() => {
      resumeTimeout();
    });
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", {
        class: "fh-toast-item",
        onMouseenter: pauseTimeout,
        onMouseleave: resumeTimeout
      }, [
        createVNode(FhIcon, {
          size: "sm",
          class: "fh-toast-item-variant",
          icon: variantIconMap[unref(variant)],
          color: variantIconColorMap[unref(variant)]
        }, null, 8, ["icon", "color"]),
        createElementVNode("div", _hoisted_1, [
          typeof ((_a = __props.toast) == null ? void 0 : _a.content) === "string" ? (openBlock(), createBlock(FhText, {
            key: 0,
            variant: "body-md"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.toast.content), 1)
            ]),
            _: 1
          })) : (openBlock(), createBlock(resolveDynamicComponent(__props.toast.content), normalizeProps(mergeProps({ key: 1 }, __props.toast.props)), null, 16))
        ]),
        unref(dismissible) || !unref(autoClose) ? (openBlock(), createBlock(FhIconButton, {
          key: 0,
          icon: unref(close),
          size: "xs",
          variant: "plain",
          onClick: withModifiers(hideToast, ["prevent"])
        }, {
          default: withCtx(() => [
            createTextVNode(" Dismiss ")
          ]),
          _: 1
        }, 8, ["icon"])) : createCommentVNode("", true)
      ], 32);
    };
  }
};
const FhToastItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-cba7e278"]]);
export {
  FhToastItem as default
};
//# sourceMappingURL=FhToastItem.mjs.map
